import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectCurrentPageEntities} from '@ngneat/elf-pagination';

import {reportStore} from '@store/reports/reports.store';

export const getReportsDataSource = createRequestDataSource({
  store: reportStore,
  data$: () => reportStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getReports',
  dataKey: 'reports',
});
